import app from 'flarum/forum/app';
import icon from 'flarum/common/helpers/icon';
import ItemList from 'flarum/common/utils/ItemList';
import Post from 'flarum/forum/components/Post';
import PostUser from 'flarum/forum/components/PostUser';

const translationPrefix = 'kilowhat-wordpress.forum.summary-post.';

export default class WordpressSummaryPost extends Post {
    cardVisible: boolean = false

    oninit(vnode) {
        super.oninit(vnode);

        this.subtree.check(() => this.cardVisible);
    }

    elementAttrs() {
        const attrs = super.elementAttrs() as any;

        attrs.className = (attrs.className || '') + ' KilowhatWordpressSummaryPost';

        return attrs;
    }

    content() {
        const content = this.attrs.post.content() as any;

        return super.content().concat([
            m('.KilowhatWordpressSummaryPost-Article', [
                content.url ? m('a.Button.KilowhatWordpressSummaryPost-Link', this.linkAttrs(content.url), [
                    app.translator.trans(translationPrefix + 'blog_link'),
                    ' ',
                    icon('fas fa-external-link-alt'),
                ]) : null,
                m('.KilowhatWordpressSummaryPost-Head', this.headerItems().toArray()),
                content.title ? m('h2', content.title) : null,
                this.thumbnailPart(),
                content.body ? m.trust(content.body) : null,
                (content.isExcerpt && content.url) ? m('.KilowhatWordpressSummaryPost-ExcerptMore', m('a.Button', this.linkAttrs(content.url), [
                    app.translator.trans(translationPrefix + 'read_more'),
                ])) : null,
            ]),
        ]);
    }

    linkAttrs(url: string) {
        return {
            href: url,
            target: '_blank',
            rel: 'noopener',
        };
    }

    headerItems() {
        const items = new ItemList<any>();

        if (app.forum.attribute('kilowhatWordpressShowDiscussionAuthor')) {
            items.add('user',
                PostUser.component({
                    post: this.attrs.post,
                    cardVisible: this.cardVisible,
                    oncardshow: () => {
                        this.cardVisible = true;
                        m.redraw();
                    },
                    oncardhide: () => {
                        this.cardVisible = false;
                        m.redraw();
                    },
                }),
                100
            );
        }

        items.add('type', m('span.KilowhatWordpressSummaryPost-Wordpress', app.translator.trans(translationPrefix + 'head_label')), 50);

        return items;
    }

    thumbnailPart() {
        if ((app.forum.attribute('kilowhatWordpressShowDiscussionThumbnail') as string[] || []).indexOf('summary') === -1) {
            return null;
        }

        const content = this.attrs.post.content() as any;

        if (!content.thumbnailUrl) {
            return null;
        }

        const img = m('img', {
            src: content.thumbnailUrl,
            alt: content.title || app.translator.trans('kilowhat-wordpress.forum.thumbnail_alt_fallback'),
        });

        if (content.url) {
            return m('a.KilowhatWordpressSummaryPost-Thumbnail', this.linkAttrs(content.url), img);
        }

        return m('.KilowhatWordpressSummaryPost-Thumbnail', img);
    }
}
